import $ from "jquery";
import React from "react";

class NounProjectFooter extends React.Component {
    componentDidMount() {
        setTimeout(() => {
            this.setState({ loading: false });
        }, 1000);
    }

    constructor(props) {
        super(props);

        this.state = {
            loading: true
        };
    }

    render() {
        if (!this.state.loading) {
            return (
                <section
                    id="footer"
                    className="footer padding-t-xl padding-b-xxl"
                >
                    <div className="container row">
                        <header className="col-sm-6 col-xs-12 margin-b-xl">
                            <a className="footer_logo" href="/">
                                <span className="ui_logo" />
                                Noun Project
                            </a>
                        </header>
                        <ul className="social col-sm-6 col-xs-12 margin-b-xl">
                            <li>
                                <a
                                    href="https://twitter.com/nounproject"
                                    className="ui_twitter"
                                    title="Noun Project Twitter"
                                    target="_blank"
                                >
                                    <span>Noun Project Twitter</span>
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://www.facebook.com/thenounproject"
                                    className="ui_facebook"
                                    title="Noun Project Facebook"
                                    target="_blank"
                                >
                                    <span>Noun Project Facebook</span>
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://instagram.com/nounproject/"
                                    className="ui_instagram"
                                    title="Noun Project Instagram"
                                    target="_blank"
                                >
                                    <span>Noun Project Instagram</span>
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://dribbble.com/nounproject"
                                    className="ui_dribbble"
                                    title="Noun Project Dribble"
                                    target="_blank"
                                >
                                    <span>Noun Project Dribble</span>
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://www.behance.net/noun_project"
                                    className="ui_behance"
                                    title="Noun Project Behance"
                                    target="_blank"
                                >
                                    <span>Noun Project Behance</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="container row">
                        <ul className="footer-navigation col-lg-2 col-md-2 col-sm-2 col-xs-12">
                            <li>The Project</li>
                            <li>
                                <a href="/about/" title="About">
                                    About
                                </a>
                            </li>
                            <li>
                                <a href="/creators/" title="Icon Creators">
                                    Icon Creators
                                </a>
                            </li>
                            <li>
                                <a
                                    href="http://blog.thenounproject.com/"
                                    title="Blog"
                                    target="_blank"
                                >
                                    Blog
                                </a>
                            </li>
                            <li>
                                <a
                                    href="http://iconathon.org/"
                                    title="Icnathon"
                                    target="_blank"
                                >
                                    Iconathon
                                </a>
                            </li>
                        </ul>
                        <ul className="footer-navigation col-lg-2 col-md-2 col-sm-2 col-xs-12">
                            <li className="list-header">Pricing</li>
                            <li>
                                <a href="/pricing/" title="NounPro Pricing">
                                    NounPro
                                </a>
                            </li>
                            <li>
                                <a href="/team/" title="Teams Pricing">
                                    Teams
                                </a>
                            </li>
                            <li>
                                <a href="/for-edu/" title="Education Pricing">
                                    Education
                                </a>
                            </li>
                        </ul>
                        <ul className="footer-navigation col-lg-2 col-md-2 col-sm-2 col-xs-12">
                            <li className="list-header">Products</li>
                            <li>
                                <a href="/apps/" title="Apps &amp; Plugins">
                                    Apps &amp; Plugins
                                </a>
                            </li>
                            <li>
                                <a href="/developers/" title="Icon API">
                                    Icon API
                                </a>
                            </li>
                            <li>
                                <a href="/nounji/" title="Nounji for iMessages">
                                    Nounji
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://lingoapp.com"
                                    title="Lingo"
                                    target="_blank"
                                >
                                    Lingo
                                </a>
                            </li>
                        </ul>
                        <div className="outreach col-lg-6 col-md-6 col-sm-6 col-xs-12">
                            <form
                                id="email-updates"
                                className="email-signup mailer"
                                action="/mailing-list/subscribe/"
                                name="mc-embedded-subscribe-form"
                                method="post"
                                noValidate=""
                                onSubmit={this.onEmailSubmit.bind(this)}
                            >
                                <label
                                    htmlFor="EMAIL"
                                    className={"email-added margin-b-m"}
                                >
                                    Subscribe to the Noun Gazette,
                                    <div className="weight-light">
                                        our monthly creative digest
                                    </div>
                                </label>
                                <span className="email-signup-feedback">
                                    {this.state.emailText}
                                </span>
                                <input
                                    id="EMAIL"
                                    name="email"
                                    type="email"
                                    placeholder="Enter your email"
                                    className={this.state.emailInputClass}
                                />
                            </form>
                            <ul className="footer-extra-links display-flex margin-t-xxl">
                                <li>
                                    <a href="/jobs/" title="Jobs">
                                        Jobs
                                    </a>
                                </li>
                                <li>
                                    <a href="/legal/" title="Legal">
                                        Legal
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="https://thenounproject.zendesk.com/"
                                        target="_blank"
                                        title="Support"
                                    >
                                        Customer Support
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="mailto:info@thenounproject.com?subject=Wanted%20to%20get%20in%20contact"
                                        title="Contact"
                                    >
                                        Contact
                                    </a>
                                </li>
                                <li>© Noun Project Inc.</li>
                            </ul>
                        </div>
                    </div>
                </section>
            );
        } else {
            // loading markup
            return (
                <section
                    id="footer"
                    className="footer padding-t-xl padding-b-xxl"
                >
                    <div className="container row">
                        <header className="col-sm-6 col-xs-12 margin-b-xl">
                            <h1 className="footer_logo">
                                <span className="ui_logo" />Noun Project
                            </h1>
                        </header>
                    </div>
                    <div className="container row">
                        <ul className="footer-navigation col-lg-2 col-md-2 col-xs-12">
                            <li>The Project</li>
                            <li>
                                <a href="/about/" title="About">
                                    About
                                </a>
                            </li>
                            <li>
                                <a href="/creators/" title="Icon Creators">
                                    Icon Creators
                                </a>
                            </li>
                            <li>
                                <a
                                    href="http://blog.thenounproject.com/"
                                    title="Blog"
                                    target="_blank"
                                >
                                    Blog
                                </a>
                            </li>
                            <li>
                                <a
                                    href="http://iconathon.org/"
                                    title="Icnathon"
                                    target="_blank"
                                >
                                    Iconathon
                                </a>
                            </li>
                        </ul>
                        <ul className="footer-navigation col-lg-2 col-md-2 col-sm-2 col-xs-12">
                            <li className="list-header">Pricing</li>
                            <li>
                                <a href="/pricing/" title="NounPro Pricing">
                                    NounPro
                                </a>
                            </li>
                            <li>
                                <a href="/team/" title="Teams Pricing">
                                    Teams
                                </a>
                            </li>
                            <li>
                                <a href="/for-edu/" title="Education Pricing">
                                    Education
                                </a>
                            </li>
                        </ul>
                        <ul className="footer-navigation col-lg-2 col-md-2 col-sm-2 col-xs-12">
                            <li className="list-header">Products</li>
                            <li>
                                <a href="/apps/" title="Apps &amp; Plugins">
                                    Apps &amp; Plugins
                                </a>
                            </li>
                            <li>
                                <a href="/developers/" title="Icon API">
                                    Icon API
                                </a>
                            </li>
                            <li>
                                <a href="/nounji/" title="Nounji for iMessages">
                                    Nounji
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://lingoapp.com"
                                    title="Lingo"
                                    target="_blank"
                                >
                                    Lingo
                                </a>
                            </li>
                        </ul>
                    </div>
                </section>
            );
        }
    }

    onEmailSubmit(e) {
        e.preventDefault();
        return $.post(e.target.action, $(e.target).serialize()).done(
            (_this => data => {
                if (data.success) {
                    _this.setState({
                        emailClass: "ui_heart email-added",
                        emailInputClass: "hidden",
                        emailText: gettext("Thanks for subscribing!")
                    });
                }
                if (data.alreadySubscribed) {
                    return _this.setState({
                        emailClass: "ui_heart email-added",
                        emailInputClass: "hidden",
                        emailText: gettext("You're already subscribed.")
                    });
                }
            })(this)
        );
    }
}

module.exports = NounProjectFooter;
